<template>
    <transition name="fade">
        <div>
            <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
            <div class="row">
                <div class="col-12 text-center">
                    <h3 class="bold">What are you applying for?</h3>
                    <hr>
                </div>
            </div>
            <div class="card bg-gray2 bl">
                <div class="card-body">
                    <div class="row px-md-4">
                        <!-- <h3 class="bold">RISE UP Loan Programs</h3> -->
                        <h3 class="bold">Loan Programs</h3>
                    </div>
                    <div class="row px-md-4">
                        <div class="row px-md-4 justify-content-center">

                            <Falah col="col-lg-3" />
                            
                            <div class="col-lg-3 d-flex">
                                <div class="card flex-fill border border-warning riseup-mp">
                                    <img class="card-img-top mt-3" src="images/rise1.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p class="text-justify">RISE UP Multi-purpose Loan is for micro, small, and medium multi-sectoral enterprises including existing SBCorp borrowers. </p>
                                    </div>
                                    <div class="card-footer bg-none mx-auto">
                                        <button type="button" class="btn btn-success btn-lg px-5" data-toggle="modal" data-target="#modalRP">APPLY</button>
                                    </div>
                                </div>
                            </div>
                          
                            <ERF col="col-lg-3" />


                            <div class="col-lg-3 d-flex">
                                <div class="card flex-fill border border-warning riseup-mp">
                                    <img class="card-img-top mt-3 px-3" src="images/rise3.svg" alt="Card image cap">
                                    <div class="card-body">
                                        <p class="text-justify">RISE UP Tindahan Loan is for sari-sari stores, retail stores, dealers, and distributors with accreditation from an SBCorp partner FMCG.</p>
                                    </div>
                                    <div class="card-footer bg-none mx-auto">
                                        <button type="button" class="btn btn-success btn-lg px-5" @click="showFMCG()">APPLY</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <NewLoan />
                </div>
            </div>




            <!-- <ERF /> -->

            <!-- <div class="card bg-gray2 bl">
                <div class="card-body">

                    <div class="row px-md-4">
                        <h3 class="bold">Other SBCorp Programs</h3>
                    </div>

                    <div class="row px-md-4">
                        <div class="col-lg-2 d-flex"></div>
                        <div class="col-lg-4 d-flex">
                            <div class="card flex-fill border border-secondary riseup-tindahan">
                                <img class="card-img-top mt-2" src="images/heroes2.jpg">
                                <div class="card-body">
                                    <h4 class="bold mt-1">HEROES is for repatriated and returning OFWs who want to start their own businesses.</h4>
                                </div>

                                <div class="card-footer bg-none mx-auto">
                                    <button type="button" class="btn btn-success btn-lg px-5" @click="selectedLoan('cares', 'FIB01', '-OH')">APPLY</button>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 d-flex">
                            <div class="card flex-fill border border-secondary riseup-tindahan">
                                <img class="card-img-top mt-2" src="images/month13.jpg" alt="Card image cap">
                                <div class="card-body">
                                    <h4 class="bold mt-1">13<sup>th</sup> Month Pay loan is for operating MSMEs with contribution payment made within 2022 to the Social Security System (SSS)</h4>
                                </div>
                                <div class="card-footer bg-none mx-auto">
                                    <button type="button" class="btn btn-success btn-lg px-5" @click="selectedLoan('rise-up', 'FIB16', '-R3')">APPLY</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 d-flex"></div>
                    </div>
                </div>
            </div> -->

            <div class="modal fade" id="modalRP" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Which RISE UP Multi-Purpose Loan are you applying for?</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="row px-md-4">
                                <div class="col-lg-4 d-flex">
                                    <div class="card flex-fill bg-gray">
                                        <div class="card-body">
                                            <h4 class="bold text-center bl">Micro Multi-Purpose Loan</h4>
                                            <p class="text-justify bl">For MSMEs with at least one (1) year business track record and loan requirement of up to PhP 300,000.00</p>
                                        </div>
                                        <div class="card-footer bg-none mx-auto">
                                            <button type="button" class="btn btn-success btn-lg px-5" @click="selectedLoan('rise-up', 'FIB10', '-MP')">APPLY</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 d-flex">
                                    <div class="card flex-fill bg-gray">
                                        <div class="card-body">
                                            <h4 class="bold text-center bl">First-Time Borrower</h4>
                                            <!-- <p class="text-justify bl">For MSMEs with at least three (3) years business track record and loan requirement of more than PhP 300,000.00. Requires submission of previous three (3) years BIR-filed Financial Statements.</p> -->
                                            <p class="text-justify bl">For MSMEs with at least two (2) years business track record and loan requirement of more than PhP 300,000.00. Requires submission of previous two (2) years BIR-filed Financial Statements.</p>
                                        </div>
                                        <div class="card-footer bg-none mx-auto">
                                            <button type="button" class="btn btn-success btn-lg px-5" @click="selectedLoan('rise-up', 'FIB11', '-FT')">APPLY</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 d-flex">
                                    <div class="card flex-fill bg-gray">
                                        <div class="card-body">
                                            <h4 class="bold text-center bl">Suki Loan</h4>
                                            <p class="text-justify bl">For existing borrowers of SBCorp in good standing, with at least six (6) months repayment track record.</p>
                                        </div>
                                        <div class="card-footer bg-none mx-auto">
                                            <button type="button" class="btn btn-success btn-lg px-5" @click="showModalSukiPN()">APPLY</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalDOT" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">DOT accreditation number</h5>
                        </div>
                        <!-- <div class="modal-body">

                            <div class="form-group">
                                <label>Please enter your DOT accreditation number</label>
                                <input class="form-control text-uppercase" v-model="dot_number" :class="{'is-invalid': submitting && $v.dot_number.$error}">
                            </div>
                        </div> -->



                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && ($v.formDOT.number.$error || $v.formDOT.yn.$error)">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>


                            <p>Do you have a Department of Tourism (DOT) accreditation number?</p>
                            <div class="row">
                                <div class="col-6 text-center">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="ydot" value="Y" v-model="formDOT.yn">
                                        <label for="ydot" :class="{ 'errorRadio': submitting && $v.formDOT.yn.$error }">Yes</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="ndot" value="N" v-model="formDOT.yn" @change="formDOT.number=null, submitting=false">
                                        <label for="ndot" :class="{ 'errorRadio': submitting && $v.formDOT.yn.$error }">No</label>
                                    </div>
                                </div>
                            </div>


                            <div class="row" v-if="formDOT.yn=='Y'">
                                <div class="col-12">
                                    <hr>
                                    <div class="alert alert-danger2 alert-dismissible mb-2" v-if="msg">
                                        <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                        <p class="text-justify p-0 m-0">{{msg}}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Please enter your DOT accreditation number</label>
                                        <input class="form-control text-uppercase" v-model="formDOT.number" :class="{'is-invalid': submitting && $v.formDOT.number.$error}">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" @click="closeModalDot">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitTravelRiseUp()">Submit</button>
                            <!-- <button type="button" class="btn btn-primary" @click="submitTravel()">Submit</button> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalActoo" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Institutional Partner/s</h5>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Select Institutional Partner/s</label>
                                <select class="form-control custom-select-sm" v-model='formInst.type' :class="{'is-invalid': submitting && $v.formInst.type.$error}">
                                    <option selected disabled :value='null'>- Select -</option>
                                    <option value="1">ACTOO</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="formInst.type">
                                <label>Category</label>
                                <select class="form-control custom-select-sm" v-model='formInst.cat' :class="{'is-invalid': submitting && $v.formInst.cat.$error}">
                                    <option selected disabled :value='null'>- Select -</option>
                                    <option value="1">With Truck-for-Hire</option>
                                    <option value="2">Without Truck-for-Hire</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="formInst.type">
                                <label>Please upload your ACTOO Certificate of Membership in Good Standing</label>
                                <div class="input-group">
                                    <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="actoo" @change="uploadAttach($event)">
                                    <input type="text" v-if="formInst.ATT124" class="form-control form-control-sm ro" @click="browseRef('actoo')" readonly :value="formInst.n124">
                                    <input type="text" v-else class="form-control form-control-sm ro" readonly value="Choose a file.." :class="{'is-invalid': submitting && $v.formInst.ATT124.$error}" @click="browseRef('actoo')">
                                    <div class="input-group-append">
                                        <button class="btn btn-sm btn-outline-primary" @click="browseRef('actoo')">
                                            <span v-if="formInst.ATT124 ">Change</span>
                                            <span v-else>Attach</span>
                                        </button>
                                        <button v-if="formInst.ATT124" class="btn btn-sm btn-outline-primary ml-2" @click="viewAttachFile(formInst.ATT124, 'ACTOO Certificate of Good Standing')">View</button>
                                    </div>
                                </div>

                                <div class="mt-1">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="progress" v-if="formInst.u124">
                                                <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+formInst.u124+ ';'">
                                                    {{formInst.u124}}
                                                </div>
                                            </div>
                                            <!-- <span v-else class="badge" :class="doc.status">{{$parent.attStat(doc.status)}}</span> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitActoo">Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalHeroes" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Heroes</h5>
                        </div>
                        <div class="modal-body">
                            <div class="alert alert-danger alert-dismissible mb-2" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                <p class="text-justify p-0 m-0">{{msg}}</p>
                            </div>
                            <div class="form-group">
                                <label>Please enter your Training Certificate No.</label>
                                <input class="form-control text-uppercase" v-model="tc_no" :class="{'is-invalid': submitting && $v.tc_no.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitHeroes('cares', 'FIB01', '-OH')">Submit</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalFMCG" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">RISE UP Tindahan <span class="fs-16">(Sari-Sari Stores, Mini-Groceries, Dealers, Distributors and others)</span></h5>
                        </div>
                        <div class="modal-body">
                            <transition name="fade">
                                <div class="alert alert-danger alert-dismissible mb-2" v-if="msg">
                                    <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                    <p class="text-justify p-0 m-0">{{msg}}</p>
                                </div>
                            </transition>
                            <div class="form-group">
                                <label>Please enter your <b>Store ID/Account ID/FMCG Reference No.</b></label>
                                <input class="form-control text-uppercase" v-model="fmcg_no" :class="{'is-invalid': submitting && $v.fmcg_no.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" @click="closeModalStaple">Cancel</button>
                            <!-- <button type="button" class="btn btn-primary" @click="submitFMCG('staples', 'FIB06', '-O3')">Submit</button> -->
                            <button type="button" class="btn btn-primary" @click="submitFMCG()">Submit</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalDOLE" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For 13<sup>th</sup> Month Pay Loan</h5>
                        </div>
                        <div class="modal-body">
                            <transition name="fade">
                                <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="msg">
                                    <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                    <p class="text-justify p-0 m-0">{{msg}}</p>
                                </div>

                            </transition>
                            <div class="form-group">
                                <label>Please enter your DOLE ERS Number</label>
                                <input class="form-control text-uppercase" v-model="dole_no" :class="{'is-invalid': submitting && $v.dole_no.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" @click="closeModalDOLE">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitHeroes('cares3', 'FIB01', '-O3')">Submit</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalOdette2" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Odette (ERF) Program</h5>
                        </div>
                        <div class="modal-body">

                            <div class="card-body mt-n3">
                                <p class="card-text">Only businesses affected by Typhoon Odette and located in the following Regions will be eligible to apply for this loan:</p>
                                <ul style="list-style: none;">
                                    <li>- Region IV-B;</li>
                                    <li>- Region VI;</li>
                                    <li>- Region VII;</li>
                                    <li>- Region VIII;</li>
                                    <li>- Region X and;</li>
                                    <li>- Region XIII</li>
                                </ul>

                                <p>Is your business located in any of the regions listed above?</p>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="text-center">
                                            <button @click="showOdetteModal" class="btn btn-primary"><span class="mx-3">Yes</span></button>
                                            <button data-dismiss="modal" class="btn btn-outline-primary"><span class="mx-3">No</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalSukiDocList" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Documentary Requirements</h5>
                        </div>
                        <div class="modal-body">
                            <div class="card-body mt-n3">
                                <p class="card-text bold">If for Fixed assets acquisition</p>
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>Latest GIS (for corporations)</li>
                                    <li>Articles of Partnership (for partnerships)</li>
                                    <li>Mayor’s Permit (for the current year)</li>
                                    <li>Secretary’s Certificate or Board Resolution or Partnership Resolution</li>
                                    <li>Proof of Bank Account or Electronic Money Account</li>
                                    <!-- <li>Three (3) photos and one (1) one-minute video showing the business signage, inventories, and fixed assets</li> -->
                                    <li>Three (3) photos showing the business signage, inventories, and fixed assets</li>
                                </ul>
                                <hr>
                                <p class="card-text bold">For Other Loan Purpose</p>
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>Latest GIS (for corporations)</li>
                                    <li>Articles of Partnership (for partnerships)</li>
                                    <li>Mayor’s Permit (for the current year)</li>
                                    <li>Secretary’s Certificate or Board Resolution or Partnership Resolution</li>
                                    <li>Proof of Bank Account or Electronic Money Account</li>
                                </ul>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="nextSuki()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalTindahanDocList" tabindex="-1" role="dialog" aria-labelledby="title" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold" id="title">Documentary Requirements</h5>
                        </div>
                        <div class="modal-body">
                            <div class="card-body mt-n3">
                                <p class="card-text bold">Existing Borrower</p>
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>Proof of Bank Account or Electronic Money Account</li>
                                    <p class="card-text mt-1">- Three (3) pictures showing the following:</p>
                                    <ul style="list-style: none; margin-left: -10px;">
                                        <li>a. Business signage;</li>
                                        <li>b. Inventories; and,</li>
                                        <li>c. Fixed assets</li>
                                    </ul>
                                </ul>
                                <hr>
                                <p class="card-text bold">New Borrower</p>
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>At least one (1) valid ID</li>
                                    <li>A selfie holding the same ID</li>
                                    <li>Proof of bank account or electronic money account</li>
                                    <li>Barangay Permit (previous or current year) for loan up to PhP100.0 thousand</li>
                                    <li>Mayor’s Permit OR Barangay Micro Business Enterprise (BMBE) Certificate (previous or current year) for loan more than PhP100.0 thousand </li>
                                    <li>In case the business permits are not available, Certification from barangay stating that the business has been in operation for at least one (1) years.</li>
                                    <li>GIS (for corporations) / Articles of Partnership (for partnership)</li>
                                    <li>Secretary’s Certificate or Board Resolution or Partnership Resolution (for corporation and partnership)</li>

                                    <p class="card-text mt-1">- Three (3) pictures showing the following:</p>
                                    <ul style="list-style: none; margin-left: -10px;">
                                        <li>a. Business signage;</li>
                                        <li>b. Inventories; and,</li>
                                        <li>c. Fixed assets</li>
                                    </ul>
                                </ul>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="nextTindahan()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>




            <div class="modal fade" id="modalRiseUpFT" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Documentary Requirements</h5>
                        </div>
                        <div class="modal-body">

                            <div class="card-body mt-n3">
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>At least one (1) valid ID of the sole proprietor / managing partner / President / CEO</li>
                                    <li>A selfie holding the same ID</li>
                                    <li>For partnerships and corporations, Secretary’s Certificate or Board Resolution or Partnership Resolution that authorizes the President/CEO/managing partner to negotiate/obtain a loan from SB Corporation.</li>
                                    <li>Latest General Information Sheet (for corporations) or Articles of Partnership (for partnerships).</li>
                                    <li>Proof of bank account or electronic money account (must be under the name of the sole proprietor, sole proprietorship, partnership, or corporation).</li>
                                    <li>Barangay Permit for loan up to PhP100.0 thousand</li>
                                    <li>Mayor’s Permit or Barangay Micro Business Enterprise (BMBE) Certificate for loan More than PhP100.0 thousand </li>
                                </ul>


                                <p class="card-text mt-1">- Three (3) pictures showing the following:</p>
                                <ul style="list-style: none; margin-left: -10px;">
                                    <li>a. Business signage;</li>
                                    <li>b. Inventories; and,</li>
                                    <li>c. Fixed assets</li>
                                </ul>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button data-dismiss="modal" class="btn btn-outline-primary"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary" @click="nextRiseUpFT()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalRiseUpTurismo" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">Documentary Requirements</h5>
                        </div>
                        <div class="modal-body">

                            <div class="card-body mt-n3">
                                <ul style="list-style: '-  '; margin-left: -20px;">
                                    <li>At least one (1) valid ID of the sole proprietor / managing partner / President / CEO</li>
                                    <li>A selfie holding the same ID</li>
                                    <li>For partnerships and corporations, Secretary’s Certificate or Board Resolution or Partnership Resolution that authorizes the President/CEO/managing partner to negotiate/obtain a loan from SB Corporation.</li>
                                    <li>Latest General Information Sheet (for corporations) or Articles of Partnership (for partnerships).</li>
                                    <li>Proof of bank account or electronic money account (must be under the name of the sole proprietor, sole proprietorship, partnership, or corporation).</li>
                                    <li>Barangay Permit for loan up to PhP100.0 thousand</li>
                                    <li>Mayor’s Permit or Barangay Micro Business Enterprise (BMBE) Certificate for loan More than PhP100.0 thousand </li>
                                </ul>

                                <p class="card-text mt-1">Three (3) pictures showing the following:</p>
                                <ul style="list-style: none; margin-left: -10px;">
                                    <li>a. Business signage;</li>
                                    <li>b. Inventories; and,</li>
                                    <li>c. Fixed assets</li>
                                </ul>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button data-dismiss="modal" class="btn btn-outline-primary"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary" @click="nextRiseUpTurismo()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>




            <div class="modal fade" id="modalOdette" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Odette (ERF) Program</h5>
                        </div>
                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && $v.exist_loan.$error">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>

                            <p>Do you have a/an previous or existing loan in Small Business Corporation? </p>
                            <div class="row">
                                <div class="col-6 text-center">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="y1" value="Y" v-model="exist_loan">
                                        <label for="y1" :class="{ 'errorRadio': submitting && $v.exist_loan.$error }">Yes</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="n1" value="N" v-model="exist_loan">
                                        <label for="n1" :class="{ 'errorRadio': submitting && $v.exist_loan.$error }">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="closeModalOdette"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="submitOdette('erf', 'FIB08', '-OD')">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <div class="modal fade" id="modalSukiPN" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For RISE UP Suki Loan</h5>
                        </div>
                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && $v.pnno.$error">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>

                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                <p class="text-justify p-0 m-0">{{msg}}</p>
                            </div>

                            <div class="form-group">
                                <label>Please enter your Promissory Note Number</label>
                                <input class="form-control text-uppercase" v-model="pnno" :class="{'is-invalid': submitting && $v.pnno.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="pnno=null,msg=null" data-dismiss="modal"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="getRiseUpSuki()">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="modal fade" id="modalSukiPN" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For RISE UP Suki Loan</h5>
                        </div>
                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && $v.pnno.$error">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>

                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                <p class="text-justify p-0 m-0">{{msg}}</p>
                            </div>
                            <div class="form-group">
                                <label>Select Business Type</label>
                                <select class="form-control custom-select-sm" v-model="formSuki.bus_type" :class="{'is-invalid': submitting && $v.formSuki.bus_type.$error}">
                                    <option selected disabled :value='null'>- Select -</option>
                                    <option value="BT2020001">Sole Proprietorship</option>
                                    <option value="BT2020002">Partnership</option>
                                    <option value="BT2020004">Corporation</option>
                                    <option value="BT2020003">Cooperative</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="formSuki.bus_type && formSuki.bus_type != 'BT2020001'">
                                <label>Please enter your Business Name</label>
                                <input class="form-control text-uppercase" v-model="formSuki.bus_name" :class="{'is-invalid': submitting && $v.formSuki.bus_name.$error}" />
                            </div>
                            <div class="form-group">
                                <label>Please enter your Promissory Note Number</label>
                                <input class="form-control text-uppercase" v-model="formSuki.pnno" :class="{'is-invalid': submitting && $v.formSuki.pnno.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="formSuki.pnno=null,formSuki.bus_type=null,formSuki.bus_name=null,msg=null" data-dismiss="modal"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="getRiseUpSuki()">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>




            <div class="modal fade" id="modalOdettePN" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Odette (ERF) Program</h5>
                        </div>
                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && $v.pnno.$error">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>

                            <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="msg">
                                <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                <p class="text-justify p-0 m-0">{{msg}}</p>
                            </div>

                            <div class="form-group">
                                <label>Please enter your Promissory Note Number</label>
                                <input class="form-control text-uppercase" v-model="pnno" :class="{'is-invalid': submitting && $v.pnno.$error}">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" data-dismiss="modal"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="getOdettePN">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <div class="modal fade" id="modalOdetteDOT" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">For Odette (ERF) Program</h5>
                        </div>
                        <div class="modal-body">
                            <alert-dismissible :category="'alert-danger2'" :toggle="submitting && ($v.formOdette.dot.$error || $v.formOdette.dot_no.$error)">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible>



                            <div>
                                <p>Are your business a tourism industry?</p>
                                <div class="row">
                                    <div class="col-6 text-center">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="y3" value="Y" v-model="formOdette.industry">
                                            <label for="y3" :class="{ 'errorRadio': submitting && $v.formOdette.industry.$error }">Yes</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="n3" value="N" v-model="formOdette.industry" @change="formOdette.dot=null, submitting=false">
                                            <label for="n3" :class="{ 'errorRadio': submitting && $v.formOdette.industry.$error }">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div v-if="formOdette.industry=='Y'">
                                <p>Do you have a Department of Tourism (DOT) accreditation number?</p>
                                <div class="row">
                                    <div class="col-6 text-center">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="y2" value="Y" v-model="formOdette.dot">
                                            <label for="y2" :class="{ 'errorRadio': submitting && $v.formOdette.dot.$error }">Yes</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="n2" value="N" v-model="formOdette.dot" @change="formOdette.dot_no=null, submitting=false">
                                            <label for="n2" :class="{ 'errorRadio': submitting && $v.formOdette.dot.$error }">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="formOdette.dot=='Y'">
                                <div class="col-12">
                                    <hr>
                                    <div class="alert alert-danger2 alert-dismissible mb-2" v-if="msg">
                                        <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                                        <p class="text-justify p-0 m-0">{{msg}}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Please enter your DOT accreditation number</label>
                                        <input class="form-control text-uppercase" v-model="formOdette.dot_no" :class="{'is-invalid': submitting && $v.formOdette.dot_no.$error}">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="closeModalOdetteDOT()"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="backOdetteDOT()"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="submitOdetteDOT('erf', 'FIB08', '-OD')">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="modal fade" id="modalPayment" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">File a Contact Request</h5>
                        </div>
                        <div class="modal-body">

                            <!-- <alert-dismissible :category="'alert-danger2'" :toggle="submitting && ($v.paymentATT.$error)">
                                <template v-slot:content>
                                    <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                </template>
                            </alert-dismissible> -->

                            <section v-if="loan_bus_code == 'FIB12' || loan_bus_code == 'FIB13' || loan_bus_code == 'FIB14'">
                                <p class="card-text text-justify">Is your balance already settled?</p>
                                <div class="row">
                                    <div class="col-6 text-center">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="y-q1" :value="1" v-model="paymentATT.settled" />
                                            <label for="y-q1" :class="{ 'errorRadio': submitting && $v.paymentATT.settled.$error }">Yes</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="n-q1" :value="0" v-model="paymentATT.settled" @click="paymentATT.with_proof=null, paymentATT.reason_no_proof=null, paymentATT.ATT128=null, paymentATT.n128='Choose a file..'">
                                            <label for="n-q1" :class="{ 'errorRadio': submitting && $v.paymentATT.settled.$error }">No</label>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section class="my-3" v-if="paymentATT.settled == 1">
                                <p class="card-text text-justify">Do you have a proof of complete payment? </p>
                                <div class="row">
                                    <div class="col-6 text-center">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="y-q2" :value="1" v-model="paymentATT.with_proof" @click="paymentATT.reason_no_proof=null" />
                                            <label for="y-q2" :class="{ 'errorRadio': submitting && $v.paymentATT.with_proof.$error }">Yes</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="icheck-primary d-inline">
                                            <input type="radio" id="n-q2" :value="0" v-model="paymentATT.with_proof" @click="paymentATT.ATT128=null, paymentATT.n128='Choose a file..'">
                                            <label for="n-q2" :class="{ 'errorRadio': submitting && $v.paymentATT.with_proof.$error }">No</label>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section v-if="paymentATT.with_proof === 0">
                                <div class="form-group">
                                    <label>Kindly input your reason of having no proof of payment.</label>
                                    <input type="text" class="form-control form-control-sm" v-model="paymentATT.reason_no_proof" :class="{'is-invalid': submitting && $v.paymentATT.reason_no_proof.$error}">
                                </div>
                            </section>

                            <section v-if="proofPayment">
                                <div class="form-group">
                                    <label>Please upload your Proof of Payment</label>
                                    <div class="input-group">
                                        <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="att128" @change="uploadAttach($event)">
                                        <input type="text" v-if="paymentATT.ATT128" class="form-control form-control-sm ro" @click="browseRef('att128')" readonly :value="paymentATT.n128">
                                        <input type="text" v-else class="form-control form-control-sm ro" readonly :value="paymentATT.n128" @click="browseRef('att128')" :class="{'is-invalid': submitting && $v.paymentATT.ATT128.$error}">
                                        <div class="input-group-append">
                                            <button class="btn btn-sm btn-outline-primary" @click="browseRef('att128')">
                                                <span v-if="paymentATT.ATT128">Change</span>
                                                <span v-else>Attach</span>
                                            </button>
                                            <button v-if="paymentATT.ATT128" class="btn btn-sm btn-outline-primary ml-2" @click="viewAttachFile(paymentATT.ATT128, 'Proof of Payment')">View</button>
                                        </div>
                                    </div>
                                    <div class="mt-1">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="progress" v-if="paymentATT.u128">
                                                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+paymentATT.u128+ ';'">
                                                        {{paymentATT.u128}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="cancelModalPayment"><i class="fas fa-times mr-1"></i>Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" @click="submitPastDue">Submit<i class="fas fa-arrow-right ml-1"></i></button>

                        </div>
                    </div>
                </div>
            </div>

            <modal-file :attachFile="attachFile" @close="closeModalFile" />
        </div>
    </transition>
</template>

<script>
    import AlertDismissible from "@vues/alerts/AlertDismissible.vue";
    import ModalFile from './ModalFile.vue';
    import ERF from './ERF.vue';
    import NewLoan from './NewLoan.vue';
    import Falah from './Falah.vue';
    import {
        required,
        requiredIf
    } from 'vuelidate/lib/validators';
    export default {
        props: ['user'],
        components: {
            'modal-file': ModalFile,
            "alert-dismissible": AlertDismissible,
            ERF,
            NewLoan,
            Falah
        },
        data() {
            return {
                failed_fmcg: 0,
                existing_borrower: null,
                api: {
                    riseup_list: false,
                    riseup_id: false,
                },
                pastdue: null,
                loan_bus_code: null,
                paymentATT: {
                    u128: 0,
                    n128: 'Choose a file..',
                    ATT128: null,

                    settled: null,
                    with_proof: null,
                    reason_no_proof: null
                },

                formDOT: {
                    number: null,
                    yn: null,
                },
                // dot_number: null,
                // dot_yn:null,
                fmcg_no: null,
                dole_no: null,
                tc_no: null,
                submitting: false,
                msg: null,
                loan_process: [],
                ceiling: null,
                pnno: null,
                track: null,

                attachFile: {
                    url: null,
                    title: null,
                    type: null,
                },


                formInst: {
                    type: null,
                    cat: null,
                    u124: null,
                    ATT124: null,
                    n124: null
                },

                exist_loan: null,
                relamt_ceil: null,
                fund: null,

                formOdette: {
                    dot: null,
                    dot_no: null,
                    industry: null,
                },
                formSuki: {
                    pnno: null,
                    bus_type: null,
                    bus_name: null,
                },

            }
        },
        validations: {
            paymentATT: {
                ATT128: {
                    required: requiredIf(function() {
                        if (this.loan_bus_code == 'FIB12' || this.loan_bus_code == 'FIB13') {
                            return this.paymentATT.with_proof == 1;
                        } else {
                            return true;
                        }
                    })
                },
                settled: {
                    required: requiredIf(function() {
                        if (this.loan_bus_code == 'FIB12' || this.loan_bus_code == 'FIB13') {
                            return true;
                        }
                        return false;
                    })
                },

                with_proof: {
                    required: requiredIf(function() {
                        if (this.loan_bus_code == 'FIB12' || this.loan_bus_code == 'FIB13') {
                            return this.paymentATT.settled == 1;
                        }
                        return false;
                    })
                },
                reason_no_proof: {
                    required: requiredIf(function() {
                        if (this.loan_bus_code == 'FIB12' || this.loan_bus_code == 'FIB13') {
                            return this.paymentATT.with_proof == 0;
                        }
                        return false;
                    })
                },
            },

            formDOT: {
                number: {
                    required: requiredIf(function() {
                        if (this.formDOT.yn == 'Y') {
                            return true;
                        }
                        return false;
                    })
                },
                yn: {
                    required
                }
            },
            formInst: {
                cat: {
                    required
                },
                type: {
                    required
                },
                ATT124: {
                    required
                },
            },
            fmcg_no: {
                required
            },
            dole_no: {
                required
            },

            tc_no: {
                required
            },
            pnno: {
                required
            },

            //odette
            exist_loan: {
                required
            },
            formOdette: {

                industry: {
                    required
                },
                dot: {
                    required: requiredIf(function() {
                        if (this.formOdette.industry == 'Y') {
                            return true;
                        }
                        return false;
                    })
                },
                dot_no: {
                    required: requiredIf(function() {
                        if (this.formOdette.dot == 'Y') {
                            return true;
                        }
                        return false;
                    })
                },
            },
            formSuki: {
                pnno: {
                    required
                },
                bus_type: {
                    required
                },
                bus_name: {
                    required: requiredIf(function() {
                        if (this.formSuki.bus_type == 'BT2020001') {
                            return false;
                        }
                        return true;
                    })
                },
            },


            // exist_loan: {
            //     required
            // },
            // formOdette.industry: {
            //     required
            // },
            // formOdette.dot: {
            //     required: requiredIf(function() {
            //         if (this.formOdette.industry == 'Y') {
            //             return true;
            //         }
            //         return false;
            //     })
            // },
            // formOdette.dot_no: {
            //     required: requiredIf(function() {
            //         if (this.formOdette.dot == 'Y') {
            //             return true;
            //         }
            //         return false;
            //     })
            // },
        },
        created() {},
        methods: {
            swalIneligible(message) {
                Swal.fire({
                    icon: 'warning',
                    html: `<p class="mx-n2 text-justify">${message}</p>`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowOutsideClick: false,

                })
            },

            applyStartup() {
                this.$parent.payloading = true;
                axios.post('/api/startup-qualification')
                    .then(res => {
                        this.$parent.payloading = false;
                        let data = res.data;
                        let ineligible = data.ineligible ?? false;
                        if (ineligible) {
                            this.swalIneligible(data.message);
                        } else {
                            this.$router.push('/apply-loan/startup');
                        }
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            openSoon() {
                Swal.fire({
                    icon: "info",
                    title: "Notice",
                    text: `This program will be available soon.`,
                    allowOutsideClick: false,
                }).then((response) => {});
            },
            submitPastDue: _.debounce(function() { // p=program, l=loan_type, e=extention
                this.submitting = true;
                this.$v.paymentATT.$touch();
                if (this.$v.paymentATT.$invalid) {} else {
                    this.$parent.payloading = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.paymentATT.u128 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                        }.bind(this)
                    }
                    let formData = new FormData();

                    formData.append('borrower_name', this.pastdue.borrower_name);
                    formData.append('borrower', this.pastdue.borrower);
                    formData.append('business_name', this.pastdue.business_name);
                    formData.append('program', this.pastdue.program);

                    formData.append('upload_file', this.paymentATT.ATT128);
                    formData.append('attach_code', 'ATT128');
                    formData.append('reason_no_proof', this.paymentATT.reason_no_proof);
                    formData.append('settled', this.paymentATT.settled);

                    axios.post('/api/v2-rise-up-send-amm', formData, config)
                        .then(res => {
                            $('#modalPayment').modal('hide');

                            Swal.fire({
                                icon: 'success',
                                text: 'Submitted successfully',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                            })
                            this.paymentATT.ATT128 = null;
                            this.paymentATT.u128 = 0;
                            this.paymentATT.n128 = 'Choose a file..';

                            this.paymentATT.with_proof = null;
                            this.paymentATT.settled = null;
                            this.paymentATT.reason_no_proof = null;
                            this.loan_bus_code = null;

                            this.$parent.payloading = false;
                        }).catch(err => {
                            this.$parent.payloading = false;
                        })
                }
            }, 333),

            cancelModalPayment() {
                $('#modalPayment').modal('hide');
                this.paymentATT.ATT128 = null;
                this.paymentATT.u128 = 0;
                this.paymentATT.n128 = 'Choose a file..';
                this.paymentATT.with_proof = null;
                this.paymentATT.settled = null;
                this.paymentATT.reason_no_proof = null;
                this.loan_bus_code = null;
            },

            showOdetteModal() {
                $('#modalOdette2').modal('hide');
                $('#modalOdette').modal('show');
            },

            closeModalOdetteDOT() {
                $('#modalOdetteDOT').modal('hide');
                this.formOdette.dot = null;
                this.formOdette.dot_no = null;
                this.exist_loan = null;
                this.fund = null;
                this.relamt_ceil = null;
            },

            backOdetteDOT() {
                $('#modalOdette').modal('show');
                $('#modalOdetteDOT').modal('hide');
                this.formOdette.dot = null;
                this.formOdette.dot_no = null;
                this.fund = null;
                this.relamt_ceil = null;
            },
            submitOdette(a, b, c) {
                this.submitting = true;
                this.$v.exist_loan.$touch();
                if (this.$v.exist_loan.$invalid) {} else {
                    if (this.exist_loan == 'Y') {
                        $('#modalOdette').modal('hide');
                        $('#modalOdettePN').modal('show');
                    } else {
                        this.getOdetteList();
                    }
                }
            },

            submitOdetteDOT() {
                this.submitting = true;
                this.$v.formOdette.$touch();

                if (this.$v.formOdette.$invalid) {} else {
                    if (this.formOdette.industry == 'N') {
                        $('#modalOdetteDOT').modal('hide');
                        let p = 'erf';
                        let l = 'FIB08';
                        let e = '-OD';
                        if (this.exist_loan == 'Y') {
                            if (this.fund == 'P3') {
                                this.generateOdetteAppID(p, l, e, 1, this.relamt_ceil, this.pnno);
                            } else {
                                this.generateOdetteAppID(p, l, e, 2, this.relamt_ceil, this.pnno);
                            }
                        } else {
                            this.generateOdetteAppID('erf', 'FIB08', '-OD', '3', null);
                        }

                    } else {
                        if (this.formOdette.dot == 'Y') {
                            this.generateOdetteDOT('erf', 'FIB08', '-OD', '4', this.formOdette.dot_no);
                        } else {
                            $('#modalOdetteDOT').modal('hide');
                            this.generateOdetteAppID('erf', 'FIB08', '-OD', '4', null);
                        }
                    }
                }
            },

            sendEmailAMM(form) {
                this.$parent.payloading = true;
                axios.post('api/v2-rise-up-send-amm', form)
                    .then(res => {
                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },

            getRiseUpR3(loan_code) {
                this.api.riseup_list = true;
                axios.get('/api/v2-rise-up-list-month13', {
                        params: {
                            borrower_id: this.user[0].borrower_id,
                            borrower_name: this.name_borrower,
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        this.generateRiseUpID('rise-up', loan_code, '-R3', data.existing);

                        // if (data.qualified == 0) {
                        //     Swal.fire({
                        //         icon: 'info',
                        //         html: `
                        //             <p class="fs-18 mx-n2 text-justify bold">The 13th Month Pay Loan Facility offering for 2022 is limited to previous 13th Month Pay Loan borrowers in good standing.</p>
                        //             <p class="fs-18 mx-n2 text-justify">For inquiries and concerns, kindly reach out to us thru any of the following:</p>
                        //             <p class="fs-18 mx-n2 text-left">Landline: 5328 1100 to 10 or 5328 1112 to 16 local 1731 and 1753</p>
                        //             <p class="fs-18 mx-n2 text-left">Mobile: 0921 5131790 (Smart) 0927 8350382 (Globe)</p>
                        //             <p class="fs-18 mx-n2 text-left">Email: sbcorporation@sbcorp.gov.ph</p>
                        //         `,
                        //         allowOutsideClick: false,
                        //         allowEscapeKey: false,
                        //         allowOutsideClick: false,
                        //         confirmButtonText: 'Ok',
                        //     });
                        // } else {
                        //     // alert('next');
                        //     this.generateRiseUpID('rise-up', loan_code, '-R3', 1);
                        // }
                        this.api.riseup_list = false;
                    }).catch(err => {
                        this.api.riseup_list = false;
                    })
            },
            getRiseUpList(loan_code) {
                this.api.riseup_list = true;
                axios.get('/api/v2-rise-up-list', {
                        params: {
                            borrower_id: this.user[0].borrower_id,
                            borrower_name: this.name_borrower,
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        let existing_borrower = data.existing;
                        this.pastdue = data.pastdue;

                        this.loan_bus_code = loan_code;

                        if (data.status == 1) {
                            Swal.fire({
                                    icon: 'info',
                                    html: '<p class="fs-18 mx-n2 text-justify">Our records show that you have unpaid balance.To help you proceed with your application, please click the <b>“File a Contact Request”</b> button and our Account Management Officer will call you back within the day.</p>',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'File a Contact Request',
                                    cancelButtonText: 'Cancel',
                                    showCancelButton: true,
                                })
                                .then((result) => {
                                    if (result.value) {
                                        $('#modalPayment').modal('show');
                                    }
                                });
                        } else {
                            switch (loan_code) {
                                case 'FIB10':
                                    this.generateRiseUpID('rise-up', loan_code, '-MP', existing_borrower);
                                    break;
                                case 'FIB12':
                                case 'FIB13':
                                    $('#modalRiseUpTurismo').modal('show');
                                    break;
                                default:
                            }
                        }
                        this.existing_borrower = existing_borrower;
                        this.api.riseup_list = false;
                    }).catch(err => {
                        this.api.riseup_list = false;
                    })
            },
            nextRiseUpFT() {
                $('#modalRiseUpFT').modal('hide');
                this.generateRiseUpID('rise-up', 'FIB11', '-FT', 0)
            },
            nextRiseUpTurismo() {
                $('#modalRiseUpTurismo').modal('hide');
                $('#modalDOT').modal('show');
            },
            getRiseUpFT() {
                this.api.riseup_list = true;
                axios.get('/api/v2-rise-up-ft', {
                        params: {
                            borrower_id: this.user[0].borrower_id,
                            borrower_name: this.name_borrower
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        let existing_borrower = data.existing;
                        // if (existing_borrower == 1) {
                        //     Swal.fire({
                        //         icon: 'info',
                        //         html: '<p class="fs-18 mx-n2 text-justify">This lending program is for new SB Corporation loan applicants only.</p>',
                        //         allowOutsideClick: false,
                        //         allowEscapeKey: false,
                        //         allowOutsideClick: false,
                        //         confirmButtonText: 'Ok',
                        //     });
                        // } else {
                        //     $('#modalRiseUpFT').modal('show');
                        // }
                        $('#modalRiseUpFT').modal('show');
                        this.existing_borrower = existing_borrower;
                        this.api.riseup_list = false;
                    }).catch(err => {
                        this.api.riseup_list = false;
                    })
            },
            swalSuki(msg) {
                Swal.fire({
                    icon: "info",
                    title: "Notice",
                    text: msg,
                    allowOutsideClick: false,
                }).then((response) => {});
            },
            swalContactRequest() {
                Swal.fire({
                        icon: 'info',
                        html: '<p class="fs-18 mx-n2 text-justify">Our records show that you have unpaid balance.To help you proceed with your application, please click the <b>“File a Contact Request”</b> button and our Account Management Officer will call you back within the day.</p>',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'File a Contact Request',
                        cancelButtonText: 'Cancel',
                        showCancelButton: true,
                    })
                    .then((result) => {
                        if (result.value) {
                            $('#modalPayment').modal('show');
                        }
                    });
            },
            showModalSukiPN() {
                this.pnno = null;
                this.msg = null;
                $('#modalRP').modal('hide');
                $('#modalSukiPN').modal('show');
            },
            nextSuki() {
                $('#modalSukiDocList').modal('hide');
                this.$router.push('/apply-loan/sblaf-rise-up-suki');
            },
            nextTindahan() {
                $('#modalTindahanDocList').modal('hide');
                this.$router.push('/apply-loan/rise-up-tindahan');
            },
            getRiseUpSuki() {
                this.submitting = true;
                this.$v.formSuki.$touch();
                if (this.$v.formSuki.$invalid) {} else {
                    this.sukiValidate();
                }
            },
            sukiValidate() {
                this.$parent.payloading = true;
                axios.post('/api/v2-rise-up-suki', {
                        borrower_id: this.user[0].borrower_id,
                        borrower_name: this.name_borrower,
                        pnno: this.formSuki.pnno,
                        bus_type: this.formSuki.bus_type,
                        bus_name: this.formSuki.bus_name,
                    })
                    .then(response => {
                        let res = response.data;
                        this.loan_bus_code = 'FIB14';
                        if (res.status == 0) {
                            // this.swalSuki(res.message);
                            this.msg = res.message
                        }
                        if (res.status == 2) {
                            this.pastdue = res.pastdue;
                            $('#modalSukiPN').modal('hide');
                            this.swalContactRequest();
                        }
                        if (res.status == 1) {
                            $('#modalSukiPN').modal('hide');
                            this.loan_process = res.loan_process;
                            $('#modalSukiDocList').modal('show');
                        }
                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            getOdetteList() {
                this.$parent.payloading = true;
                axios.get('/api/v2-odette-list', {
                        params: {
                            borrower_id: this.user[0].borrower_id,
                            borrower_name: this.name_borrower
                        }
                    })
                    .then(res => {

                        let data = res.data
                        if (data.status == 1) {

                            let list = res.data.list;
                            this.ceiling = list.relamt_ceil;

                            if (list.status == 'Past Due') {
                                $('#modalOdette').modal('hide');
                                Swal.fire({
                                        icon: 'info',
                                        html: '<p class="fs-18 mx-n2 text-justify">Our records show that you have unpaid balance. If you have any questions, please contact our Customer Relationship Manager by sending an email to sbcorporation@sbcorp.gov.ph or call via 8651-3333 and 1-800-10-651-3333 (nationwide toll-free).</p>',
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                    })
                                    .then((result) => {

                                    });
                            } else {
                                $('#modalOdette').modal('hide');
                                $('#modalOdettePN').modal('show');
                            }
                        } else {
                            $('#modalOdette').modal('hide');
                            $('#modalOdetteDOT').modal('show');
                        }
                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;

                    })
            },
            getOdettePN() {
                this.msg = null;
                this.track = null;
                this.submitting = true;
                this.$v.pnno.$touch();
                if (this.$v.pnno.$invalid) {} else {
                    this.$parent.payloading = true;
                    axios.get('/api/v2-odette-pnno', {
                            params: {
                                pnno: this.pnno,
                                borrower_id: this.user[0].borrower_id,
                                borrower_name: this.name_borrower
                            }
                        })
                        .then(res => {
                            let data = res.data


                            if (data.status == 1) {
                                this.track = data.track;
                                this.fund = data.ceiling[0].fund;
                                this.relamt_ceil = data.ceiling[0].relamt_ceil;
                                let status = data.ceiling[0].status;


                                if (status == 'Past Due') {
                                    $('#modalOdettePN').modal('hide');
                                    Swal.fire({
                                            icon: 'info',
                                            html: '<p class="fs-18 mx-n2 text-justify">Our records show that you have unpaid balance. If you have any questions, please contact our Customer Relationship Manager by sending an email to sbcorporation@sbcorp.gov.ph or call via 8651-3333 and 1-800-10-651-3333 (nationwide toll-free).</p>',
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                        })
                                        .then((result) => {

                                        });
                                } else {
                                    this.exist_loan = 'Y';
                                    $('#modalOdettePN').modal('hide');
                                    $('#modalOdetteDOT').modal('show');
                                }
                            } else {
                                this.msg = data.msg;
                            }

                            this.$parent.payloading = false;
                        }).catch(err => {
                            this.$parent.payloading = false;

                        })
                }

            },
            generateOdetteDOT(p, l, e, t, d) {
                this.$parent.payloading = true;
                axios.post('api/v2-create-odette-dot', {
                        borrower_id: this.user[0].borrower_id,
                        program: p,
                        loan_type: l,
                        ext: e,
                        track: t,
                        dot: d
                    })
                    .then(res => {
                        let data = res.data;
                        let status = data.status;

                        if (status == 1) {
                            this.loan_process = data.loan_process;
                            let program = data.loan_process.program;
                            $('#modalOdetteDOT').modal('hide');
                            this.$router.push('/apply-loan/erf-odette');
                        } else {
                            let msg = data.msg;
                            this.msg = msg;
                        }

                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            generateOdetteAppID(p, l, e, t, m, pn) {
                this.$parent.payloading = true;
                axios.post('api/v2-create-odette-app-id', {
                        borrower_id: this.user[0].borrower_id,
                        program: p,
                        loan_type: l,
                        ext: e,
                        track: t,
                        max_loan: m,
                        pnno: pn
                    })
                    .then(res => {
                        let data = res.data;
                        this.loan_process = data.loan_process;
                        let program = data.loan_process.program;

                        if (program == 'erf') {
                            this.$router.push('/apply-loan/erf-odette');
                        }

                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            closeModalOdette() {
                $('#modalOdette').modal('hide');
                this.formOdette.dot = null;
                this.formOdette.dot_no = null;
                this.exist_loan = null;
                this.fund = null;
                this.relamt_ceil = null;
            },
            generateHeroesID() {
                this.$parent.payloading = true;
                axios.post('api/v2-create-heroes-app-id', {
                        borrower_id: this.user[0].borrower_id,
                        // lastname: this.user[0].lname,
                        // firstname: this.user[0].fname,
                        tc_no: this.tc_no,
                    })
                    .then(res => {
                        let data = res.data;

                        if (data.status == 0) {
                            this.msg = data.msg;
                        } else {
                            $('#modalHeroes').modal('hide');
                            // this.loan_process = data.loan_process;
                            // let program = data.loan_process.program;
                            this.$router.push('/heroes-application');
                        }

                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            submitHeroes: _.debounce(function(p = null, l = null, e = null) { // p=program, l=loan_type, e=extention
                this.submitting = true;
                this.msg = null;

                this.$v.tc_no.$touch();
                if (this.$v.tc_no.$invalid) {} else {
                    this.generateHeroesID();
                }
            }, 333),
            noticeCutOff() {
                let src = 'images/sbc-b2c-notice.png';
                Swal.fire({
                        // icon: 'info',
                        html: "<img class='img-fluid' src='" + src + "' />",
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonText: 'Continue',
                        cancelButtonText: 'Cancel',
                        reverseButtons: true,
                        customClass: {
                            content: 'swal-content-padding0',
                        }
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            this.selectedLoan('cares3', 'FIB01', '-O3');
                        }
                    });
            },
            closeModalDOLE() {
                $('#modalDOLE').modal('hide');
                this.msg = null;
                this.dole_no = null;
            },
            closeModalDot() {
                $('#modalDOT').modal('hide');
                this.msg = null;
                this.formDOT.number = null;
                this.formDOT.yn = null;
            },
            closeModalStaple() {
                $('#modalFMCG').modal('hide');
                this.msg = null;
                this.fmcg_no = null;
            },
            submitFMCG: _.debounce(function() {
                this.submitting = true;
                this.msg = null;

                this.$v.fmcg_no.$touch();
                if (this.$v.fmcg_no.$invalid) {} else {
                    this.applyTindahan();
                }
            }, 333),
            apply13th() {
                Swal.fire({
                        icon: 'info',
                        // text: 'Please be advised  that we are processing first the applications from companies that availed of the Flexible Work Arrangements as we previously announced.But we are also studying so that companies that filed temporary closures and have reopened, or have retrenched some employees, may also be included.please standby for new advisories.',
                        html: '<p class="fs-18 mx-n2 text-justify">Please be advised  that we are processing first the applications from companies that availed of the Flexible Work Arrangements as we previously announced.</p><p class="fs-18 mx-n2 mb-0 text-justify">But we are also studying so that companies that filed temporary closures and have reopened, or have retrenched some employees, may also be included.please standby for new advisories.</p>',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    })
                    .then((result) => {
                        this.showDOLE();
                    });
            },
            submit13Month: _.debounce(function(p = null, l = null, e = null) { // p=program, l=loan_type, e=extention
                this.submitting = true;
                this.msg = null;

                this.$v.dole_no.$touch();
                if (this.$v.dole_no.$invalid) {} else {
                    this.generate13Month();
                }
            }, 333),
            generate13Month() {
                this.$parent.payloading = true;
                axios.post('api/v2-create-13month-app-id', {
                        borrower_id: this.user[0].borrower_id,
                        lastname: this.user[0].lname,
                        firstname: this.user[0].fname,
                        ref_id: this.dole_no,
                    })
                    .then(res => {
                        let data = res.data;

                        if (data.status == 0) {
                            this.msg = data.msg;
                        } else {
                            $('#modalDOLE').modal('hide');
                            this.loan_process = data.loan_process;
                            let program = data.loan_process.program;
                            this.$router.push('/apply-loan/13th-month');
                        }

                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            applyTindahan() {
                this.$parent.payloading = true;
                axios.post('api/v2-apply-rise-up-tindahan', {
                        borrower_id: this.user[0].borrower_id,
                        ref_id: this.fmcg_no,
                        borrower_name: this.name_borrower,
                    })
                    .then(response => {
                        let res = response.data;
                        this.loan_bus_code = 'FIB15';

                        if (res.status == 0) {
                            this.msg = res.message
                            this.failed_fmcg++;

                            if (this.failed_fmcg > 3) {
                                this.msg = 'Please coordinate with your partner FMCG Company for the correct FMCG Account Code.'
                            }
                        }
                        if (res.status == 2) {
                            this.pastdue = res.pastdue;
                            $('#modalFMCG').modal('hide');
                            this.swalContactRequest();
                        }
                        if (res.status == 1) {
                            $('#modalFMCG').modal('hide');
                            this.loan_process = res.loan_process;
                            $('#modalTindahanDocList').modal('show');
                        }
                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            showDOLE() {
                $('#modalDOLE').modal('show');
            },
            showFMCG() {
                if (this.user[0].borrower_id == '2020-040484-O2') {
                    return
                } else {
                    $('#modalFMCG').modal('show');
                }
            },
            closeModalFile() {
                // $('#modalActoo').modal('show');
                $('#modalPayment').modal('show');
            },
            checkMIME(file) {
                let type_img = ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG'];
                let type_pdf = ['application/pdf', 'application/PDF'];
                let type_video = ['video/MOV', 'video/mov', 'video/MPEG4', 'video/mpeg4', 'video/MP4', 'video/mp4', 'video/AVI', 'video/avi',
                    'video/WMV', 'video/wmv', 'video/MPEGPS', 'video/mpegps', 'video/FLV', 'video/flv', 'video/3GPP', 'video/3ggp', 'video/3GP', 'video/3gp', 'video/HEVC',
                    'video/hevc', 'video/WebM', 'video/wbem', 'video/DNxHR', 'video/dnxhr', 'video/ProRes', 'video/prores', 'video/CineForm', 'video/cineform'
                ];
                if (file['type']) {
                    if (type_img.includes(file['type'])) {
                        return 'img';
                    }
                    if (type_pdf.includes(file['type'])) {
                        return 'pdf';
                    }
                    if (type_video.includes(file['type'])) {
                        return 'video';
                    }
                }
            },
            viewAttachFile(file, title) {
                this.attachFile.url = window.URL.createObjectURL(file);
                this.attachFile.type = this.checkMIME(file);
                this.attachFile.title = title;
                // $('#modalActoo').modal('hide');
                $('#modalPayment').modal('hide');
                $('#modalFile').modal('show');
            },
            invalidFile() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are attaching unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            invalidFileSize() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are attaching unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            trimFilename(n, len) {
                let ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
                let filename = n.replace('.' + ext, '');
                if (filename.length <= len) {
                    return n;
                }
                filename = filename.substr(0, len) + (n.length > len ? '[-]' : '');
                return filename + '.' + ext;
            },
            uploadAttach($event) {
                let file = $event.target.files[0];
                let max_size = 1024 * 1024 * 10;
                let fileType = [
                    "image/jpeg",
                    "image/png",
                    "image/jpg",
                    "image/JPEG",
                    "image/PNG",
                    "image/JPG",
                    "application/PDF",
                    "application/pdf"
                ]
                if (file) {
                    let size = file['size'];
                    if (fileType.includes(file['type'])) {
                        // this.formInst.n124 = this.trimFilename(file.name, 10);
                        // this.formInst.ATT124 = file;

                        if (size <= max_size) {
                            this.paymentATT.n128 = this.trimFilename(file.name, 10);
                            this.paymentATT.ATT128 = file;
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Info',
                                text: 'Exceeded the maximum file size required is 10MB',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                            });
                            this.paymentATT.n128 = 'Choose a file..';
                            this.paymentATT.ATT128 = null;
                        }
                    } else {
                        this.invalidFile();
                        // this.formInst.name = null;
                        // this.formInst.ATT124 = null;

                        this.paymentATT.n128 = 'Choose a file..';
                        this.paymentATT.ATT128 = null;
                    }

                } else {}
            },
            browseRef(id) {
                document.getElementById(id).click();
            },
            submitActoo: _.debounce(function() { // p=program, l=loan_type, e=extention
                this.submitting = true;
                this.$v.formInst.$touch();
                if (this.$v.formInst.$invalid) {} else {
                    this.$parent.payloading = true;
                    axios.post('api/v2-create-app-id', {
                            borrower_id: this.user[0].borrower_id,
                            program: 'cares3',
                            loan_type: 'FIB04',
                            ext: '-O3',
                            actoo_cat: this.formInst.cat
                        })
                        .then(res => {
                            let data = res.data;
                            this.loan_process = data.loan_process;
                            let program = data.loan_process.program;

                            $('#modalActoo').modal('hide');
                            if (program == 'cares3') {
                                this.$router.push('/apply-loan/actoo');
                            }

                            this.$parent.payloading = false;
                        }).catch(err => {
                            this.$parent.payloading = false;
                        })
                }
            }, 333),

            submitTravel: _.debounce(function() {
                this.submitting = true;
                this.msg = null;
                this.title = null;

                this.$v.formDOT.$touch();
                if (this.$v.formDOT.$invalid) {

                } else {
                    if (this.formDOT.yn == 'Y') {
                        this.verifyDOT('cares3', 'FIB03', '-OT');
                    } else {
                        $('#modalDOT').modal('hide');
                        this.selectedLoan('cares3', 'FIB09', '-NT');
                    }
                }
            }, 333),
            submitTravelRiseUp: _.debounce(function() {
                this.submitting = true;
                this.msg = null;
                this.title = null;

                this.$v.formDOT.$touch();
                if (this.$v.formDOT.$invalid) {

                } else {
                    if (this.formDOT.yn == 'Y') {
                        this.verifyRiseUpDOT('rise-up', 'FIB12', '-RT', this.existing_borrower);
                    } else {
                        this.verifyRiseUpDOT('rise-up', 'FIB13', '-RN', this.existing_borrower);
                    }
                }

            }, 333),
            verifyRiseUpDOT(p = null, l = null, s = null, e = null) {
                this.$parent.payloading = true;
                axios.post('api/v2-rise-up-verify-dot-number', {
                        program: p,
                        loan_type: l,
                        suffix: s,
                        existing_borrower: e,

                        dot_number: this.formDOT.number,
                        borrower_id: this.user[0].borrower_id,
                        for_dot: this.formDOT.yn
                    })
                    .then(res => {
                        let data = res.data;

                        if (data.msg) {
                            this.msg = data.msg;
                        } else {
                            $('#modalDOT').modal('hide');
                            this.$router.push('/apply-loan/rise-up-turismo');
                        }
                        this.$parent.payloading = false;
                    }).catch(error => {
                        this.$parent.payloading = false;
                    })
            },
            verifyDOT(p = null, l = null, e = null) {
                this.$parent.payloading = true;
                axios.post('api/v2-verify-dot-number', {
                        dot_number: this.formDOT.number,
                        borrower_id: this.user[0].borrower_id,
                        program: p,
                        loan_type: l,
                        ext: e
                    })
                    .then(res => {
                        let data = res.data;

                        if (data.msg) {
                            this.msg = data.msg;
                        } else {
                            $('#modalDOT').modal('hide');
                            this.$router.push('/apply-loan/b2c');
                        }
                        this.$parent.payloading = false;
                    }).catch(error => {
                        this.$parent.payloading = false;
                    })
            },
            generateAppID(p = null, l = null, e = null) { // p=program, l=loan_type, e=extention
                this.$parent.payloading = true;
                axios.post('api/v2-create-app-id', {
                        borrower_id: this.user[0].borrower_id,
                        program: p,
                        loan_type: l,
                        ext: e
                    })
                    .then(res => {
                        let data = res.data;
                        this.loan_process = data.loan_process;
                        let program = data.loan_process.program;

                        if (program == 'cares3') {
                            this.$router.push('/apply-loan/b2c');
                        }
                        if (program == 'rise-up') {
                            this.$router.push('/apply-loan/rise-up');
                        }

                        this.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },
            generateRiseUpID(p = null, l = null, suffix = null, exist = null) { // p=program, l=loan_type, e=extention
                this.api.riseup_id = true;

                axios.post('api/v2-create-rise-up-app-id', {
                        borrower_id: this.user[0].borrower_id,
                        program: p,
                        loan_type: l,
                        suffix: suffix,
                        existing_borrower: exist
                    })
                    .then(res => {
                        let data = res.data;
                        this.loan_process = data.loan_process;
                        let program = data.loan_process.program;

                        switch (l) {
                            case 'FIB10':
                                // this.$router.push('/apply-loan/rise-up');
                                this.$router.push('/apply-loan/sblaf-rise-up-mp');
                                break;
                            case 'FIB11':
                                // this.$router.push('/apply-loan/rise-up-ft');
                                this.$router.push('/apply-loan/sblaf-rise-up-ft');
                                break;

                            case 'FIB12':
                            case 'FIB13':
                                this.$router.push('/apply-loan/rise-up-turismo');
                                break;
                            case 'FIB14':
                                // this.$router.push('/apply-loan/rise-up-suki');
                                this.$router.push('/apply-loan/sblaf-rise-up-suki');
                                break;
                            case 'FIB16':
                                this.$router.push('/apply-loan/rise-up-month13');
                                break;
                            case 'FIB17':
                                this.$router.push('/apply-loan/erf-carina');
                                break;
                            default:
                        }

                        this.api.riseup_id = false;
                    }).catch(err => {
                        this.api.riseup_id = false;
                    })
            },
            selectedLoan: _.debounce(function(p = null, l = null, e = null) { // p=program, l=loan_type, e=extention

                if (this.user[0].borrower_id == '2020-040484-O2') {
                    return
                } else {


                    if (p == 'cares3') {
                        if (l == 'FIB01' || l == 'FIB02' || l == 'FIB05' || l == 'FIB09') {
                            this.generateAppID(p, l, e);
                        }
                        // if (l == 'FIB02') {
                        //     this.generateAppID(p, l, e);
                        // }
                        // if (l == 'FIB05') {
                        //     this.generateAppID(p, l, e);
                        // }

                        if (l == 'FIB03') {
                            this.submitting = false;
                            this.formDOT.number = null;
                            this.formDOT.yn = null;
                            $('#modalDOT').modal('show');
                        }
                        if (l == 'FIB08') {
                            $('#modalOdette2').modal('show');
                        }
                    }
                    if (p == 'cares') {
                        $('#modalHeroes').modal('show');
                    }
                    if (p == 'erf') {
                        $('#modalOdette2').modal('show');
                    }
                    if (p == 'rise-up') {
                        $('#modalRP').modal('hide');
                        switch (l) {
                            case 'FIB10':
                                this.getRiseUpList(l);
                                break;
                            case 'FIB11':
                                this.getRiseUpFT();
                                break;

                            case 'FIB12':
                            case 'FIB13':
                                this.submitting = false;
                                this.formDOT.number = null;
                                this.formDOT.yn = null;
                                this.getRiseUpList(l);
                                break;
                            case 'FIB16':
                                this.getRiseUpR3(l);
                                break;
                            default:
                        }
                    }

                }
            }, 333),
        },
        computed: {
            name_borrower() {
                let name = '';
                let mname = this.user[0].mname ? this.user[0].mname : ''
                if (this.user) {
                    if (this.user[0].suffix_desc) {
                        name = this.user[0].fname + ' ' + mname + ' ' + this.user[0].lname + ' ' + this.user[0].suffix_desc;
                    } else {
                        name = this.user[0].fname + ' ' + mname + ' ' + this.user[0].lname;
                    }
                }
                return name;
            },
            proofPayment() {
                switch (this.loan_bus_code) {
                    case 'FIB12':
                    case 'FIB13':
                        return Boolean(this.paymentATT.with_proof);
                        break;
                    default:
                        return true;
                }
                return false;
            },
            processingAPI() {
                return Object.values(this.api).includes(true);
            },
        },

        mounted() {
            $('.modal').on('show.bs.modal', function() {
                this.submitting = false;
                this.msg = null;
            }.bind(this));
        }
    }
</script>
<style scoped>
    .btn-fit {
        border-radius: 0 !important;
        width: 100%;
    }

    .alert-danger2 {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    .riseup-mp {
        border-color: #fe9900 !important;
        border-width: 7px !important
    }

    .riseup-turismo {
        border-color: #263d81 !important;
        border-width: 7px !important
    }

    .riseup-tindahan {
        /* border-color: #78a236 !important; */
        border-width: 7px !important
    }

    .bg-none {
        background-color: transparent !important;
    }

    .bl {
        color: black;
    }

    .bg-gray {
        background-color: #f3f3f3 !important;
    }

    .bg-gray2 {
        background-color: #E5E5E5 !important;
    }
</style>